import * as THREE from 'three';
import ShapeRepresentation2d from '../representation2d/ShapeRepresentation2d';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineSegments2 } from 'three/addons/lines/LineSegments2.js';
import { LineSegmentsGeometry } from 'three/addons/lines/LineSegmentsGeometry.js';
import { sceneUnitsFromMm } from '../../utils/scaler';

// Amount of offset in Z-direction to avoid z-fighting
const Z_OFFSET = sceneUnitsFromMm(0.5);

const edgeMaterial = new LineMaterial({
                        color: 0x696969,
                        linewidth: 1, // Note: resolution needs to be managed if linewidth > 1
                        //resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                        dashed: false
                    });
export default class ShapeGeometry2d {
    static create(shapeRepresentation: ShapeRepresentation2d, material: THREE.Material, layer: number, position: THREE.Vector3, drawOutline: boolean): THREE.Object3D | null {
        const { outerProfile } = shapeRepresentation;
        const outerProfileClone = outerProfile.map((v: any) => new THREE.Vector2(v.x, v.y));

        if (outerProfileClone.length < 3) return null;

        const shape = new THREE.Shape(outerProfileClone);
        
        const geometry = new THREE.ShapeGeometry(shape);

        const mesh = new THREE.Mesh(geometry, material);
        mesh.layers.set(layer);

        const offsetPosition = new THREE.Vector3(   position.x, 
                                                    position.y, 
                                                    position.z + Z_OFFSET);

        mesh.position.copy(offsetPosition);

        mesh.name = "ShapeRepresentation2d";

        if (drawOutline) {
            //const edgesGeometry = new THREE.EdgesGeometry(geometry);
            //const lineMaterial = new THREE.LineBasicMaterial({ color: "black", linewidth: 100 }); // Note: linewidth usually 1 in WebGL

            const edgesProfile = outerProfile.map((v: any) => new THREE.Vector2(v.x, v.y));

            const lsg = new LineSegmentsGeometry();
            const flatPositions: number[] = [];
            for (let i = 0; i < edgesProfile.length - 1; i++) {
                 const p1 = edgesProfile[i];
                 const p2 = edgesProfile[(i + 1)]; 
                 flatPositions.push(p1.x, p1.y, 0, p2.x, p2.y, 0);
             }
             lsg.setPositions(flatPositions);
            
            const lines = new LineSegments2(lsg, edgeMaterial);
            lines.layers.set(layer);
            lines.position.copy(position);
            
            const group = new THREE.Group();
            group.add(mesh);
            group.add(lines);
            return group;
        }

        return mesh;
    }
}
